import { useApolloClient } from "@apollo/client";
import { useState } from "react";

import TalmaLogo from "../../images/talma_logo.png";
import {
  COMPLAINANT_ID,
  COMPLAINANT_INFO,
} from "../../utils/complaintsConstants";
import { CreateComplaintTypes } from "../../utils/constants";
import { USER_ROUTES } from "../../utils/routeConstants";
import CreateComplainantId from "../CreateComplainantId/CreateComplainantId";
import CreateComplainantInfo from "../CreateComplainantInfo/CreateComplainantInfo";
import CreateComplainantRegister from "../CreateComplainantRegister/CreateComplainantRegister";
import { QuejaReclamoContext } from "../QuejaReclamoContext/QuejaReclamoContext";
import Steps from "../Steps/Steps";
import { Header, MainContainer } from "./CreateComplaintStyles";
import requestData from "./requestData";
import uploadFileToS3 from "./UploadToS3";

const STEPS = [
  {
    description: "Identificación del Reclamante",
    screenName: CreateComplaintTypes.COMPLAINANT_ID,
  },
  {
    description: "Información del Caso",
    screenName: CreateComplaintTypes.COMPLAINT_INFORMATION,
  },
  {
    description: "Registro",
    screenName: CreateComplaintTypes.COMPLAINT_REGISTRATION,
  },
];

function CreateComplaint() {
  const client = useApolloClient();

  const [caseNumber, updateCaseNumber] = useState("");

  const [activeStep, updateActiveStep] = useState(
    CreateComplaintTypes.COMPLAINANT_ID
  );

  const [complainantId, updateComplainantId] = useState(COMPLAINANT_ID);

  const [complainantInfo, updateComplainantInfo] = useState(COMPLAINANT_INFO);

  const onComplainantIdFinished = () => {
    updateActiveStep(CreateComplaintTypes.COMPLAINT_INFORMATION);
  };

  const onComplainantInfoFinished = () => {
    return uploadFileToS3(
      "complaints",
      complainantInfo.files,
      "quejas-reclamos"
    )
      .then((urlFiles) =>
        requestData(client, complainantId, complainantInfo, urlFiles)
      )
      .then((response) => {
        updateCaseNumber(response.saveDemand.caseNumber);
        updateActiveStep(CreateComplaintTypes.COMPLAINT_REGISTRATION);
      });
  };

  const onComplainantInfoReturned = () => {
    updateActiveStep(CreateComplaintTypes.COMPLAINANT_ID);
  };

  const onComplainantRegisterFinished = () => {
    updateActiveStep(CreateComplaintTypes.COMPLAINANT_ID);
  };

  return (
    <>
      <Header>
        <Steps
          currentScreenName={activeStep}
          updateScreen={updateActiveStep}
          stepsInfo={STEPS}
          title={USER_ROUTES.CREATE_COMPLAINTS.title.toUpperCase()}
          makeDisable={true}
        />
        <div className="logo--container">
          <img
            className="talma--logo"
            src={TalmaLogo}
            alt="logo"
            height="21"
            width="66"
          />
        </div>
      </Header>
      <MainContainer>
        <QuejaReclamoContext.Provider
          value={[
            complainantId,
            updateComplainantId,
            complainantInfo,
            updateComplainantInfo,
          ]}
        >
          {activeStep === CreateComplaintTypes.COMPLAINANT_ID ? (
            <CreateComplainantId onFinished={onComplainantIdFinished} />
          ) : activeStep === CreateComplaintTypes.COMPLAINT_INFORMATION ? (
            <CreateComplainantInfo
              onFinished={onComplainantInfoFinished}
              onReturn={onComplainantInfoReturned}
            />
          ) : activeStep === CreateComplaintTypes.COMPLAINT_REGISTRATION ? (
            <CreateComplainantRegister
              caseNumber={caseNumber}
              onFinished={onComplainantRegisterFinished}
            />
          ) : null}
        </QuejaReclamoContext.Provider>
      </MainContainer>
    </>
  );
}

export default CreateComplaint;
